import DatePicker from './DatePicker';
import useDateRangeError from '../hooks/useDateRangeError';

const DateRangePicker = ({ dateFrom, setDateFrom, dateTo, setDateTo, onHasError }) => {
  const { setFromError, setToError, displayError } = useDateRangeError(dateFrom, dateTo, onHasError);

  return (
    <div className="date-selection">
      <div className="option-label">加入時期</div>
      <div className="date-range">
        <DatePicker
          value={dateFrom}
          onChange={(date) => setDateFrom(date)}
          placeholder="開始日"
          onError={onHasError ? setFromError : undefined}
        />
        <span className="date-separator">〜</span>
        <DatePicker
          value={dateTo}
          onChange={(date) => setDateTo(date)}
          placeholder="終了日"
          onError={onHasError ? setToError : undefined}
        />
      </div>
      {onHasError && displayError && (
        <div className="dc-field-error">{displayError}</div>
      )}
    </div>
  );
};

export default DateRangePicker;